import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useNetworkStatus from '../../Hooks/useNetworkStatus';
import './NetworkStatusIndicator.css';
import wifiIcon from './wifi.png';
import wifiOffIcon from './wifi_off.png';
import wifiSlowIcon from './wifi_slow.png';

const NetworkStatusIndicator = () => {
  const location = useLocation();
  const isConsultationPage =
    location.pathname.includes("/consultation") ||
    location.pathname.includes("/ptconsultation/") ||
    location.pathname.includes("/meet") ||
    location.pathname.includes("/meet_dr") ||
    location.pathname.includes("/meet_pt/");

  const { isOnline, isSlow, didReconnect, networkSpeed, clearReconnectStatus } = useNetworkStatus({
    isSuspended: isConsultationPage
  });
  const [isDismissed, setIsDismissed] = useState(false);

  // Reset dismiss state if the core status actually changes
  useEffect(() => {
    setIsDismissed(false);
  }, [isOnline, isSlow, didReconnect]);

  useEffect(() => {
    let timeoutId;
    if (didReconnect) {
      timeoutId = setTimeout(() => {
        clearReconnectStatus();
      }, 5000); // Hide green banner after 5 seconds
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [didReconnect, clearReconnectStatus]);

  if (isDismissed) return null;

  if (!isOnline) {
    return (
      <div className="network-status-indicator offline">
        <div className="indicator-content">
          <img src={wifiOffIcon} alt="Offline" className="indicator-icon" />
          <span className="indicator-text">
            Oops! You're Offline. Check your connection and&nbsp;
            <button className="refresh-link" onClick={() => window.location.reload()}>click here</button>
            &nbsp;to refresh.
          </span>          
        </div>
        <button className="indicator-close" onClick={() => setIsDismissed(true)}>
          <svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
        </button>
      </div>
    );
  }

  if (isSlow) {
    return (
      <div className="network-status-indicator slow">
        <div className="indicator-content">
          <img src={wifiSlowIcon} alt="Slow Connection" className="indicator-icon" />
          <span className="indicator-text">Looks like your internet is a bit slow — hang tight!</span>
          {networkSpeed && (
            <div className="indicator-speed">
              <svg className="indicator-approx" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 10 Q 8 6 12 10 T 20 10" />
                <path d="M4 15 Q 8 11 12 15 T 20 15" />
              </svg>
              <span>{networkSpeed}</span>
            </div>
          )}
        </div>
        <button className="indicator-close" onClick={() => setIsDismissed(true)}>
          <svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
        </button>
      </div>
    );
  }

  if (didReconnect) {
    return (
      <div className="network-status-indicator online">
        <div className="indicator-content">
          <img src={wifiIcon} alt="Online" className="indicator-icon" />
          <span className="indicator-text">
            Great! You're back online. Please&nbsp;
            <button className="refresh-link" onClick={() => window.location.reload()}>click here</button>
            &nbsp;to refresh.
          </span>
        </div>
        <button className="indicator-close" onClick={() => setIsDismissed(true)}>
          <svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
        </button>
      </div>
    );
  }

  return null;
};

export default NetworkStatusIndicator;
